/*eslint-disable*/
import React from 'react';
import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import assets from "assets";

const BrochureHTML = React.forwardRef(({ item }, ref) => {
  const defaultImage = 'https://via.placeholder.com/400x300?text=No+Image';
  const images = Object.values(item.images || {});
  const filledImages = [...images];
  while (filledImages.length < 6) {
    filledImages.push(defaultImage);
  }

  // ✅ Price logic
  let displayPrice = "POA";
  if (item.poa) {
    displayPrice = "POA";
  } else if (item.type === "tolet" || item.type.includes("To Let")) {
    displayPrice = `R${Number(item.grossmonthlyRental).toLocaleString()} pm`;
  } else {
    displayPrice = `R${Number(item.price).toLocaleString()} pm ex VAT`;
  }

  return (
    <div
      ref={ref}
      style={{
        width: '210mm',
        height: '297mm',
        backgroundColor: 'white',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        fontFamily: 'Arial, Helvetica, sans-serif',
        margin: '0 auto'
      }}
    >
      {/* Top Blue Header */}
      <div style={{
        backgroundColor: '#022c5e',
        color: 'white',
        padding: '8mm 10mm',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
      }}>
        <div style={{
          fontSize: '16pt',
          fontWeight: 'bold',
          lineHeight: '1.2'
        }}>
          <div>{`${item.gla}m² ${item.type === "tolet" || item.type.includes("To Let") ? "To Let" : "For Sale"}`} </div>
          <div>{item.address?.suburb ? item.address?.suburb : item.address?.description}</div>
        </div>

        <div style={{
          padding: '4mm 6mm',
          textAlign: 'center'
        }}>
          <img
            src={assets.API_Square_Logo_320px}
            alt="Company Logo"
            style={{
              width: '35mm',
              height: '35mm',
              objectFit: 'contain',
              marginTop: '4mm',
            }}
          />
        </div>
      </div>

      {/* Red line separator */}
      <div style={{
        backgroundColor: '#DC2626',
        height: '3px',
        width: '100%'
      }}></div>

      {/* Images Section */}
      <div style={{
        padding: '13mm 10mm 0',
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Main image with TO LET banner */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: '3mm',
          height: '70mm',
          marginBottom: '2mm'
        }}>
          {/* Large left image */}
          <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            backgroundColor: '#f0f0f0'
          }}>
            <img src={filledImages[0]} alt="Main Property Image" style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              maxWidth: '100%',
              maxHeight: '100%'
            }} />
            <div style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              backgroundColor: '#DC2626',
              color: 'white',
              padding: '5px 15px',
              fontSize: '16pt',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {item.type === "tolet" || item.type.includes("To Let") ? "TO LET" : "FOR SALE"}
            </div>
          </div>

          {/* Right column - 2 smaller images */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '3mm'
          }}>
            <div style={{
              width: '100%',
              height: '50%',
              overflow: 'hidden',
            }}>
              <img src={filledImages[1]} alt="Property Image 2" style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%'
              }} />
            </div>
            <div style={{
              width: '100%',
              height: '50%',
              overflow: 'hidden',
            }}>
              <img src={filledImages[2]} alt="Property Image 3" style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%'
              }} />
            </div>
          </div>
        </div>

        {/* Bottom row - 4 small images */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
          gap: '3mm',
          height: '40mm',
          marginBottom: '2mm',
          marginTop: '5mm',
        }}>
          {filledImages.slice(3, 7).map((src, idx) => (
            <div key={idx + 3} style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              borderRadius: '2px'
            }}>
              <img src={src || defaultImage} alt={`Property Image ${idx + 4}`} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                maxWidth: '100%',
                maxHeight: '100%'
              }} />
            </div>
          ))}
        </div>
      </div>

      {/* Property Details Section */}
      <div style={{
        backgroundColor: '#009ad8',
        color: 'white',
        padding: '3mm 10mm',
        fontSize: '12pt',
        fontWeight: 'bold',
        textAlign: 'center',
        textTransform: 'uppercase',
        letterSpacing: '1px'
      }}>
        PROPERTY DETAILS
      </div>

      {/* Price and Specs */}
      <div style={{
        padding: '4mm 10mm 3mm',
        backgroundColor: 'white'
      }}>
        <div style={{
          fontSize: '20pt',
          fontWeight: 'bold',
          color: '#104d8e',
          marginBottom: '1mm'
        }}>
          {displayPrice}
        </div>

        <div style={{
          fontSize: '12pt',
          color: '#104d8e',
          marginBottom: '4mm',
          fontWeight: '500'
        }}>
          {item.address?.suburb ? item.address?.suburb : item.address?.description}
        </div>

        {/* Property specifications in two columns */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '1mm 8mm',
          fontSize: '11pt',
          lineHeight: '1.6'
        }}>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>FLOOR SIZE:</span> <span style={{ color: '#1E3A8A' }}>{`${item.gla || " - "}m²`}</span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>LAND SIZE:</span> <span style={{ color: '#1E3A8A' }}>{`${item.landSize || " - "}m²`}</span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>LEASE PERIOD:</span> <span style={{ color: '#1E3A8A' }}>{`${item.leasePeriod || " - "}`}</span>
          </div>

          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>AVAILABLE FROM:</span> <span style={{ color: '#1E3A8A' }}>{`${item?.availableFrom ? item?.availableFrom : " - "}`}</span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>3 PHASE POWER:</span> <span style={{ color: '#1E3A8A' }}>{item.isThreePhase ? 'Yes' : 'No'}</span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>POWER AMPS:</span> <span style={{ color: '#1E3A8A' }}>{item.powerAmps || ' - '}</span>
          </div>
        </div>

        <div style={{
          textAlign: 'right',
          marginTop: '4mm',
          fontSize: '10pt',
          color: '#666'
        }}>
          <span style={{ fontWeight: 'bold', color: '#1E3A8A' }}>WEB REF:</span> {item.web_Ref_No}
        </div>
      </div>

      {/* Agent Section */}
      <div style={{
        backgroundColor: '#009ad8',
        color: 'white',
        padding: '2mm 5mm',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}>
        <div style={{
          fontSize: '18pt',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: '1mm'
        }}>
          {item.userdetials?.Name?.toUpperCase()} {item.userdetials?.lastName?.toUpperCase()}
        </div>
        <div style={{
          fontSize: '11pt',
          textTransform: 'uppercase',
          marginBottom: '3mm',
          letterSpacing: '0.5px'
        }}>
          INDUSTRIAL PROPERTY SPECIALIST
        </div>
        <div style={{
          display: 'flex',
          gap: '1mm',
          fontSize: '11pt',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2mm' }}>
            <span>📞</span> {item.userdetials?.mobile || '066 308 9268'}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2mm' }}>
            <span>✉</span> {item.userdetials?.email || 'pieter@apiproperty.co.za'}
          </div>
        </div>
      </div>
    </div>
  );
});

export const handleExportPDF = async (item) => {
  return new Promise(async (resolve, reject) => {
    try {
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.left = '-9999px';
      container.style.top = '-9999px';
      container.style.pointerEvents = 'none';
      container.style.opacity = 0;
      document.body.appendChild(container);

      const root = createRoot(container);
      const componentRef = React.createRef();
      root.render(<BrochureHTML item={item} ref={componentRef} />);

      await new Promise((r) => setTimeout(r, 800));

      const targetElement = container.querySelector('div[style*="210mm"]');
      if (!targetElement) {
        throw new Error("Failed to find brochure element");
      }

      const canvas = await html2canvas(targetElement, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('portrait', 'mm', 'a4');
      pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297);
      const blob = pdf.output('blob');

      root.unmount();
      document.body.removeChild(container);
      resolve(blob);
    } catch (error) {
      console.error('[PDF Generation Error]', error);
      reject(error);
    }
  });
};